import { Select } from "antd";
import { useState } from "react";

type Option = {
  label: string;
  value: string;
};

type Props = {
  value: string;
  onSelect: (value: string) => void;
  disabled?: boolean;
  options: Option[];
  allowClear?: boolean;
  showSearch?: boolean;
};

const SelectColumn = ({ value, onSelect, disabled, options, allowClear, showSearch }: Props) => {
  const [selected, setSelected] = useState(value);

  const handleSelect = (newValue: string) => {
    setSelected(newValue);
    onSelect(newValue);
  };

  return (
    <Select
      allowClear={allowClear}
      disabled={disabled}
      style={{ width: "100%" }}
      value={selected}
      onChange={handleSelect}
      options={options}
      showSearch={showSearch}
    />
  );
};

export default SelectColumn;
